import type { FeedbackAttachmentInput } from "../api";

export const ALLOWED_EXT_TO_TYPE: Record<string, string> = {
  png: "image/png",
  jpg: "image/jpeg",
  jpeg: "image/jpeg",
  gif: "image/gif",
  webp: "image/webp",
  pdf: "application/pdf",
  csv: "text/csv",
  txt: "text/plain",
  doc: "application/msword",
  docx: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
};

export const FEEDBACK_ACCEPT =
  "image/png,image/jpeg,image/gif,image/webp,.pdf,.csv,.txt,.doc,.docx";

export const MAX_ATTACHMENTS = 5;
export const MAX_ATTACHMENT_BYTES = 10 * 1024 * 1024;

function extOf(filename: string): string {
  const idx = filename.lastIndexOf(".");
  return idx >= 0 ? filename.slice(idx + 1).toLowerCase() : "";
}

export function isAllowedFile(file: File): boolean {
  return extOf(file.name) in ALLOWED_EXT_TO_TYPE;
}

export function fileToAttachment(file: File): Promise<FeedbackAttachmentInput> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const dataUrl = reader.result as string;
      const base64 = dataUrl.includes(",") ? dataUrl.split(",")[1] : dataUrl;
      resolve({
        filename: file.name,
        content_type: ALLOWED_EXT_TO_TYPE[extOf(file.name)],
        size_bytes: file.size,
        data: base64,
      });
    };
    reader.onerror = () => reject(reader.error);
    reader.readAsDataURL(file);
  });
}
